// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__24cAc","topBottomGutter":"Layout_topBottomGutter__34m6C"};